import {createPreloadableLazyComponent} from '../../../../util/lazyImport';
import type * as Panel2 from '../panel';
import {inputType} from './common';

export {EXTENSION_INFO, processTextForDisplay} from './common';

export const Spec: Panel2.PanelSpec = {
  id: 'text',
  Component: createPreloadableLazyComponent(() => import('./Component'))
    .Component,
  inputType,
};
